// import React, { useState } from "react";
// import { Btn } from "../../styles/Button.styled";
// import { Container } from "../../styles/Sidebar/UploadModal.styled";
// import Popup from "../Popup/Popup";
// import { useAppDispatch, useAppSelector } from "../../hooks";
// import { Input } from "../inputs/Input";
// import {
//   AutocompleteInputCustom,
//   OptionAutocompleteInputCustom,
// } from "../inputs/AutocompleteInputCustom";
// import { signerDocAdd } from "../../actions/signers";
// import { CircularProgress } from "@mui/material";

// interface Signer {
//   id?: string;
//   email: string;
//   code: string;
// }

// const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

// export function AddSignersPopup({
//   handleClose,
//   ...doc
// }: {
//   handleClose: () => void;
//   [key: string]: any;
// }) {
//   const dispatch = useAppDispatch();
//   const counterparties = useAppSelector((state) => state.counterparties);
//   const signerAddState = useAppSelector((state) => state.signerAdd);

// const [signers, setSigners] = useState<Signer[]>([{ email: "", code: "" }]);
 
//   const [signer, setSigner] = useState<Signer>({
//     email: "",
//     code: ""
//   });
//   const [errors, setErrors] = useState<{
//     email?: string;
//     code?: string;
//     system?: string;
//   }>({});
//   const [activeSave, setActiveSave] = useState(false);

//   const closePopup = () => handleClose();

// const handleAddSigner = () => {
//    setSigners((prev) => [...prev, { email: "", code: "" }]);
//  };

//   const handleSignerChange = (field: keyof Signer, value: string) => {
//     setActiveSave(true);
//    setSigners((prev) =>
//       prev.map((s, i) => (i === index ? { ...s, [field]: value } : s)),
//    );

// const handleRemoveSigner = (index: number) => {
//     if (signers.length === 1) return;
//    setSigners((prev) => prev.filter((_, i) => i !== index));
//  };

//     // валідація в реальному часі
//     if (field === "email") {
//       if (!value.trim()) {
//         setErrors((prev) => ({ ...prev, email: "Вкажіть email підписанта" }));
//       } else if (!EMAIL_REGEX.test(value)) {
//         setErrors((prev) => ({ ...prev, email: "Невірний формат email" }));
//       } else {
//         setErrors((prev) => ({ ...prev, email: undefined }));
//       }
//     }

//     if (field === "code") {
//       const digits = value.replace(/\D/g, "");
//       if (!digits) {
//         setErrors((prev) => ({ ...prev, code: "Вкажіть ЄДРПОУ/ІПН" }));
//       } else if (digits.length < 8) {
//         setErrors((prev) => ({ ...prev, code: "Мінімум 8 цифр" }));
//       } else if (digits.length > 10) {
//         setErrors((prev) => ({ ...prev, code: "Максимум 10 цифр" }));
//       } else {
//         setErrors((prev) => ({ ...prev, code: undefined }));
//       }
//     }
//   };

//   const handleSelectCounterparty = (
//     opt: OptionAutocompleteInputCustom | OptionAutocompleteInputCustom[] | null,
//   ) => {
//     if (!opt || Array.isArray(opt)) return;
//     setActiveSave(true);
//     setSigner((prev) => ({
//       ...prev,
//       id: String(opt.id),
//       email: (opt as any).email ?? prev.email,
//       code: (opt as any).company ?? prev.code,
//     }));
//     setErrors({});
//   };

//   const validate = (): boolean => {
//     const newErrors: { email?: string; code?: string; system?: string } = {};

//     if (!signer.email.trim()) {
//       newErrors.email = "Вкажіть email підписанта";
//     } else if (!EMAIL_REGEX.test(signer.email)) {
//       newErrors.email = "Невірний формат email";
//     }

//     const digits = signer.code.replace(/\D/g, "");
//     if (!digits) {
//       newErrors.code = "Вкажіть ЄДРПОУ/ІПН";
//     } else if (digits.length < 8) {
//       newErrors.code = "Мінімум 8 цифр";
//     } else if (digits.length > 10) {
//       newErrors.code = "Максимум 10 цифр";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSave = async () => {
//     if (!validate()) return;

//     try {
//       const result = await dispatch(signerDocAdd(signer, doc.id));
//       if (result?.payload?.message) {
//         setErrors({ system: result.payload.message });
//         return;
//       }
//       handleClose();
//     } catch {
//       setErrors({ system: "Помилка з'єднання з сервером" });
//     }
//   };

//   return (
//     <Popup
//       clickCloseButton={closePopup}
//       style={{height: "max-content"}}
//     >
//       <h1 >Додати контрагента</h1>
//       <Container>
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             gap: "20px",
//             padding: "10px",
//             marginTop: 4
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "16px",
//               padding: "16px",
//               backgroundColor: "var(--disabled-bg)",
//               borderRadius: "12px",
//               position: "relative",
//             }}
//           >
//             {counterparties?.list?.length > 0 && (
//               <AutocompleteInputCustom
//                 label="Обрати з контрагентів"
//                 value={signer.id}
//                 options={counterparties.list}
//                 onChange={(opt) => handleSelectCounterparty(opt)}
//                 placeholder="Пошук контрагента"
//                 labelStyle={{
//                   background:
//                     "linear-gradient(to bottom, var(--disabled-bg) 40%, var(--disabled-bg) 60%)",
//                 }}
//               />
//             )}
//             <div
//             >
//               <Input
//                 label="ЄДРПОУ/ІПН"
//                 placeholder="Введіть код"
//                 type="number"
//                 value={signer.code}
//                 maxNumber={10}
//                 onChange={(val) => handleSignerChange("code", val)}
//                 error={errors.code}
//               />
//               <Input
//                 label="Email"
//                 type="email"
//                 placeholder="Введіть email"
//                 value={signer.email}
//                 onChange={(val) => handleSignerChange("email", val)}
//                 error={errors.email}
//               />
//             </div>
//           </div>
//         </div>

//          <div
//             style={{
//               color: "var(--vivid-pink)",
//               fontSize: "13px",
//               height: "16px",
//                marginLeft: "16px",
//                marginBottom: 4
//             }}
//           >
//             {errors.system ?? " "}
//           </div>

//         <div style={{ display: "flex", gap: "10px"}}>
//           <Btn
//             type="button"
//             $width="100%"
//             $color="var(--blue)"
//             $marginTop="0"
//             style={{ flex: 1 }}
//             onClick={closePopup}
//             $background="var(--sidebar-hover)"
//             $heightMobile="47px"
//           >
//             Відмінити
//           </Btn>

//           <Btn
//             style={{ flex: 1 }}
//             type="button"
//             $width="100%"
//             $color="var(--white)"
//             $marginTop="0"
//             onClick={handleSave}
//             $background="var(--blue)"
//             $heightMobile="47px"
//             disabled={!activeSave || !!errors.email || !!errors.code}
//           >
//             {signerAddState.state === "loading" ? (
//               <CircularProgress size={24} sx={{ color: "var(--white)" }} />
//             ) : (
//               "Додати"
//             )}
//           </Btn>
//         </div>


//       </Container>
//     </Popup>
//   );
// }
import React, { useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Btn } from "../../styles/Button.styled";
import { Container } from "../../styles/Sidebar/UploadModal.styled";
import Popup from "../Popup/Popup";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { Input } from "../inputs/Input";
import { signerDocAdd } from "../../actions/signers";
import { searchContacts, CONTACTS_SEARCH_RESET } from "../../actions/contacts";
import { CircularProgress } from "@mui/material";
import { Remove } from "../../../public/icons";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import stylesSelect from "../../styles/Select.module.css";

interface Signer {
  email: string;
  code: string;
}

const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

interface SearchResult {
  id: string;
  code: string;
  email: string;
  name: string;
  companyTitle: string;
}

function SignerSearchInput({
  label, type, value, onChange, onSearch, onSelect, results, error,
}: {
  label: string;
  type?: "text" | "number" | "email";
  value: string;
  onChange: (val: string) => void;
  onSearch: (val: string) => void;
  onSelect: (r: SearchResult) => void;
  results: SearchResult[];
  error?: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownRect, setDropdownRect] = useState<DOMRect | null>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<HTMLUListElement>(null);

  const updateRect = () => {
    const rect = wrapperRef.current?.getBoundingClientRect();
    if (rect) setDropdownRect(rect);
  };

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const target = e.target as Node;
      if (
        !wrapperRef.current?.contains(target) &&
        !dropdownRef.current?.contains(target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div ref={wrapperRef}>
      <Input
        label={label}
        type={type}
        value={value}
        maxNumber={type === "number" ? 10 : undefined}
        onChange={(val) => { onChange(val); onSearch(val); updateRect(); setIsOpen(true); }}
        error={error}
      />
      {isOpen && results.length > 0 && dropdownRect && createPortal(
        <ul ref={dropdownRef} style={{
          position: "fixed",
          top: dropdownRect.bottom - 16,
          left: dropdownRect.left,
          width: dropdownRect.width,
          zIndex: 9999,
          background: "var(--white)",
          border: "1px solid #e2e8f0",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          maxHeight: "200px",
          overflowY: "auto",
          listStyle: "none",
          margin: 0,
          padding: 0,
        }}>
          {results.map((r) => (
            <li key={r.id}>
              <button
                type="button"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => { onSelect(r); setIsOpen(false); }}
                style={{
                  width: "100%", textAlign: "left", padding: "10px 14px",
                  background: "none", border: "none", cursor: "pointer",
                  fontSize: "13px", display: "flex", flexDirection: "column", gap: "2px",
                }}
              >
                <span style={{ fontWeight: 600 }}>
                  {r.code}
                  {r.companyTitle && (
                    <span style={{ fontWeight: 400, color: "var(--disabled-c)" }}> {r.companyTitle}</span>
                  )}
                </span>
                <span style={{ color: "var(--login-gray)" }}>
                  {r.email}{r.name && ` · ${r.name}`}
                </span>
              </button>
            </li>
          ))}
        </ul>,
        document.body
      )}
    </div>
  );
}

export function AddSignersPopup({
  handleClose,
  ...doc
}: {
  handleClose: () => void;
  docId: string;
  [key: string]: any;
}) {
  const dispatch = useAppDispatch();
  const signerAddState = useAppSelector((state) => state.signerAdd);
  const contactsSearch = useAppSelector((state) => state.contactsSearch);

  const [signers, setSigners] = useState<Signer[]>([{ email: "", code: "" }]);
  const [errors, setErrors] = useState<{
    [key: number]: { email?: string; code?: string };
    system?: string;
  }>({});
  const docId = doc.id;

  const searchTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleSearch = useCallback((field: "code" | "email", value: string) => {
    if (searchTimer.current) clearTimeout(searchTimer.current);
    if (!value || value.trim().length < 2) {
      dispatch({ type: CONTACTS_SEARCH_RESET });
      return;
    }
    searchTimer.current = setTimeout(() => {
      dispatch(searchContacts({ [field]: value.trim() }) as any);
    }, 300);
  }, [dispatch]);

  const searchResults: SearchResult[] = contactsSearch.list.flatMap((group: any) =>
    group.accounts.map((account: any) => ({
      id: account.id,
      code: group.company.code || account.code,
      email: account.email,
      name: [account.lastname, account.firstname, account.middlename].filter(Boolean).join(" "),
      companyTitle: group.company.title,
    }))
  );

  const closePopup = () => handleClose();

  const handleAddSigner = () => {
    setSigners((prev) => [...prev, { email: "", code: "" }]);
  };

  const handleRemoveSigner = (index: number) => {
    if (signers.length === 1) return;
    setSigners((prev) => prev.filter((_, i) => i !== index));
    setErrors((prev) => {
      const copy = { ...prev };
      delete copy[index];
      return copy;
    });
  };

  const handleSignerChange = (index: number, field: keyof Signer, value: string) => {
    setSigners((prev) =>
      prev.map((s, i) => (i === index ? { ...s, [field]: value } : s))
    );

    let fieldError: string | undefined;

    if (field === "email") {
      if (!value.trim()) fieldError = "Вкажіть email підписанта";
      else if (!EMAIL_REGEX.test(value)) fieldError = "Невірний формат email";
    }
    if (field === "code") {
      const digits = value.replace(/\D/g, "");
      if (!digits) fieldError = "Вкажіть ЄДРПОУ/ІПН";
      else if (digits.length < 8) fieldError = "Мінімум 8 цифр";
      else if (digits.length > 10) fieldError = "Максимум 10 цифр";
    }

    setErrors((prev) => ({
      ...prev,
      [index]: { ...(prev[index] || {}), [field]: fieldError },
    }));
  };

  const handleSelectResult = (index: number, result: SearchResult) => {
    setSigners((prev) =>
      prev.map((s, i) =>
        i === index ? { ...s, code: result.code, email: result.email } : s
      )
    );
    setErrors((prev) => ({ ...prev, [index]: {} }));
  };

  const validate = (): boolean => {
    const currentErrors: typeof errors = {};
    let isValid = true;

    signers.forEach((signer, index) => {
      const rowErrors: { email?: string; code?: string } = {};

      if (!signer.email.trim()) { rowErrors.email = "Вкажіть email підписанта"; isValid = false; }
      else if (!EMAIL_REGEX.test(signer.email)) { rowErrors.email = "Невірний формат email"; isValid = false; }

      const digits = signer.code.replace(/\D/g, "");
      if (!digits) { rowErrors.code = "Вкажіть ЄДРПОУ/ІПН"; isValid = false; }
      else if (digits.length < 8) { rowErrors.code = "Мінімум 8 цифр"; isValid = false; }
      else if (digits.length > 10) { rowErrors.code = "Максимум 10 цифр"; isValid = false; }

      if (Object.keys(rowErrors).length > 0) currentErrors[index] = rowErrors;
    });

    setErrors(currentErrors);
    return isValid;
  };

  const handleSave = async () => {
    if (!validate()) return;
    try {
      const promises = signers.map(({ email, code }) =>
        dispatch(signerDocAdd({ email, code }, docId))
      );
      const results = await Promise.all(promises);
      const failedResult = results.find((res) => res?.payload?.message);
      if (failedResult) {
        setErrors((prev) => ({ ...prev, system: failedResult.payload.message }));
        return;
      }
      handleClose();
    } catch {
      setErrors((prev) => ({ ...prev, system: "Помилка з'єднання з сервером" }));
    }
  };

  const hasValidationErrors = Object.keys(errors).some((key) => {
    if (key === "system") return false;
    const rowErrors = errors[Number(key)];
    return rowErrors && (Boolean(rowErrors.email) || Boolean(rowErrors.code));
  });

  const isFormFilled = signers.every((s) => s.email.trim() && s.code.trim());

  return (
    <Popup
      clickCloseButton={closePopup}
      style={{ height: "max-content", maxWidth: "550px" }}
    >
      <h1>Додати контрагентів</h1>
      <Container>
        <style>{`
          @keyframes slideIn {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animated-signer-card { animation: slideIn 0.25s ease-out forwards; }
        `}</style>

        <div style={{
          display: "flex", flexDirection: "column", gap: "20px",
          padding: "10px", marginTop: 4,
          maxHeight: "calc(80vh - 180px)", overflowY: "auto",
        }}>
          {signers.map((signer, index) => (
            <div
              key={index}
              className="animated-signer-card"
              style={{
                display: "flex", flexDirection: "column", gap: "16px",
                padding: "16px", backgroundColor: "var(--disabled-bg)",
                borderRadius: "12px", position: "relative",
              }}
            >
              {signers.length > 1 && (
                <button
                  type="button"
                  onClick={() => handleRemoveSigner(index)}
                  style={{
                    position: "absolute", top: "12px", right: "12px",
                    background: "none", border: "none", cursor: "pointer",
                    color: "var(--vivid-pink)",
                  }}
                >
                  <Remove />
                </button>
              )}
              <span style={{ fontSize: "12px", fontWeight: "bold", color: "var(--blue)" }}>
                Підписант {index === 0 ? "" : index + 1}
              </span>

              <SignerSearchInput
                label="ЄДРПОУ/ІПН"
                type="number"
                value={signer.code}
                onChange={(val) => handleSignerChange(index, "code", val)}
                onSearch={(val) => handleSearch("code", val)}
                onSelect={(r) => handleSelectResult(index, r)}
                results={searchResults}
                error={errors[index]?.code}
              />
              <SignerSearchInput
                label="Email"
                type="email"
                value={signer.email}
                onChange={(val) => handleSignerChange(index, "email", val)}
                onSearch={(val) => handleSearch("email", val)}
                onSelect={(r) => handleSelectResult(index, r)}
                results={searchResults}
                error={errors[index]?.email}
              />
            </div>
          ))}
        </div>

        <Btn
          type="button"
          $width="max-content"
          $color="var(--blue)"
          onClick={handleAddSigner}
          $background="transparent"
           className={stylesSelect.addBtn}
        >
           <div className={stylesSelect.plusIcon}>
                <AddCircleIcon
                  sx={{ height: "40px", width: "40px", color: "#E4ECFF" }}
                />
              </div>
          Додати ще одного підписанта
        </Btn>

        <div
          style={{
            color: "var(--vivid-pink)",
            fontSize: "13px",
            height: "16px",
            marginLeft: "16px",
            marginBottom: 4,
            marginTop: 10,
          }}
        >
          {errors.system ?? " "}
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <Btn
            type="button"
            $width="100%"
            $color="var(--blue)"
            $marginTop="0"
            style={{ flex: 1 }}
            onClick={closePopup}
            $background="var(--sidebar-hover)"
            $heightMobile="47px"
          >
            Відмінити
          </Btn>

          <Btn
            style={{ flex: 1 }}
            type="button"
            $width="100%"
            $color="var(--white)"
            $marginTop="0"
            onClick={handleSave}
            $background="var(--blue)"
            $heightMobile="47px"
            disabled={!isFormFilled || hasValidationErrors}
          >
            {signerAddState.state === "loading" ? (
              <CircularProgress size={24} sx={{ color: "var(--white)" }} />
            ) : (
              "Додати"
            )}
          </Btn>
        </div>
      </Container>
    </Popup>
  );
}